import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { FiMenu } from 'react-icons/fi'
import {AiOutlineClose} from 'react-icons/ai'
import logo from "../assests/img/logo.png"
import '../assests/navbar.css'

function Navbar() {
  const nav = [
    {id:1, prop: "Home", link: "/" },
    {id:2, prop: "About", link: "/about" },
    { id:4,prop: "More", link: "/more" },
    // {id:4,prop:"Help",link:"/help"},
    // { prop: "Members", link: "/members" },
    {id:3, prop: "Contact Us", link: "/contact" }
  ];
  // const more=[
  //   {id:1,prop:"Structure of SGC",link:"/structure"},
  //   {id:2,prop:"Faculty Coordinator",link:"/faculty"},
  //   {id:3,prop:"SGC Members",link:"/members",},
  //   {id:4,prop:"Credits",link:"/team"}
  // ]
  const [show, setShow] = useState(false);
  const shownav = () => {
    setShow(true);
  }
  const closenav = () => {
    setShow(false);
  }
  return (
    <>
      <div className="navbar">
        <Link className="logo" to='/'>
          <img src={logo} alt="SGC|NITC" height="50px" width="50px"></img>
        </Link>

        <div className="links">
          {
            nav.map((navs) => {
              return (
                
                <Link key={navs.id} to={navs.link}>{navs.prop}</Link>
                
              )
            })
          }
          
                {/* <Link  to="/members">More</Link> */}
          <Link className="appointment" to='/appointment'>Book Appointment</Link>
        </div>


        <div className="moblink">
          <FiMenu onClick={shownav} />
        </div>
      </div>
      {
        show &&
        <div className="moblinks">
          <div className="button">
            <AiOutlineClose onClick={closenav} />
          </div>
          {
            nav.map((navs) => {
              return (
                <Link key={navs.id} to={navs.link} onClick={closenav}>{navs.prop}</Link>
              )
            })
          }
          <Link className="appointment" to='/appointment' onClick={closenav}>Book Appointment</Link>

        </div>
      }
    </>
  )
}

export default Navbar